// extracted by mini-css-extract-plugin
export default {"btn":"admin_btn__WQpKb","adminForm":"admin_adminForm__jvq-k"};